import {NgModule, Provider} from '@angular/core';
import {HttpModule, Http, XHRBackend, RequestOptions} from '@angular/http';
import {DashboardHttp} from './dashboard.http';
import {COMMON_XHR_BACKEND_PROVIDERS} from '../../../../common/providers';

const HTTP_CLIENT_PROVIDER: Provider = {
    provide: Http,
    useFactory: (backend: XHRBackend, options: RequestOptions) => new DashboardHttp(backend, options),
    deps: [XHRBackend, RequestOptions]
};

@NgModule({
    imports: [
        HttpModule
    ],

    providers: [
        ...COMMON_XHR_BACKEND_PROVIDERS,
        HTTP_CLIENT_PROVIDER
    ],

    exports: [
        HttpModule
    ]
})
export class DashboardHttpModule {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/http/dashboard.http.module.ts